var _defs, _path, _ellipse, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDesktopWallpaper({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1920 1200",
    preserveAspectRatio: "xMidYMid slice",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "sky",
    x2: 0.8,
    y2: 1
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#103870"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#2c74b5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#539bd1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ribbon",
    x2: 0.7,
    y2: 1
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#c4edff",
    stopOpacity: 0.45
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#7fc8fc",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#134889",
    stopOpacity: 0.6
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "front",
    x2: 0,
    y2: 1
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5fafe8",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#195799",
    stopOpacity: 0.8
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "light"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#aacff0",
    stopOpacity: 0.24
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#a5dfff",
    stopOpacity: 0
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#sky)",
    d: "M0 0h1920v1200H0z"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 1410,
    cy: 190,
    rx: 890,
    ry: 790,
    fill: "url(#light)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M-140 960C490 1010 650 360 1370 365c375 3 520 135 670 320v515H-140Z",
    fill: "url(#ribbon)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M-140 960C490 1010 650 360 1370 365c375 3 520 135 670 320",
    fill: "none",
    stroke: "#c5eaff",
    strokeOpacity: 0.33,
    strokeWidth: 2
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M-100 1110C610 1285 1070 550 1640 650c160 28 260 118 360 225v325H-100Z",
    fill: "url(#front)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M-100 1110C610 1285 1070 550 1640 650c160 28 260 118 360 225",
    fill: "none",
    stroke: "#c3eaff",
    strokeOpacity: 0.2,
    strokeWidth: 2
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M-20 905C680 945 776 244 1400 286c260 18 440 132 590 310",
    fill: "none",
    stroke: "#c8eaff",
    strokeOpacity: 0.1
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDesktopWallpaper);
export default __webpack_public_path__ + "static/media/desktop-wallpaper.be8c1ea4cc04d0a96b2843bf6441960b.svg";
export { ForwardRef as ReactComponent };